import "./style.scss";
import { showHideLoadMoreButton } from "./show-hide-load-more";
import getAdditionalPosts from "./get-aditional-posts";
import Columns from 'columns.js';
require('jquery-sticky');

(function ($) {
  // Loop through all categories for each selector
  function getSelectedCategories(selector) {
    return $(selector)
      .map(function (index, element) {
        if ($(element).val().length) {
          return $(element).val();
        }
      })
      .get();
  }

  $(function () {
    const $loader = $('.grid__loader');
    let stickyFilter = $('#grid-filter');
    const stickyFilterOptions = {
      topSpacing: 30,
      zIndex: 100
    };
    let $filterContentPostion;
    let selectedCategories = $("select[multiple]")
      .map(function (index, element) {
        if ($(element).val().length) {
          return $(element).val();
        }
      })
      .get();

    const loadMoreArgs = {
      action: 'loadMore',
      page: 1,
      category: []
    }
    const $loadMoreButton = $('#load-more-front');

    const $grid = $('.grid').isotope({
      itemSelector: '.grid__item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid__sizer',
        gutter: '.grid__gutter',
      }
    });

    // Render filter items (menus) into columns
    const gridFilter = new Columns(document.getElementById('grid-filter-menu'), {
      columns: 1,
      breakpoints: {
        768: 3,
        1140: 6
      },
      column_class: 'col',
      algorithm: 'chronological',
    });

    // Load more posts based on current filters
    $(document).on('click', "#load-more-front", function (event) {
      const $currentButton = $(event.currentTarget);
      $currentButton.addClass('active').attr('disabled', true);
      loadMoreArgs.page++;
      const offset = $(this).attr('data-offset');
      const additionalPosts = $(this).attr('data-additional-posts');
      const nextPosts = getAdditionalPosts({ ...loadMoreArgs, offset, additionalPosts, type: 'post' });
      nextPosts.then(function (data) {
        const isotopeElements = $.parseHTML($.trim(data.html));
        $grid.isotope('insert', isotopeElements);
        $grid.imagesLoaded()
          .done(function () {
            $grid.isotope('layout');
          });
        $currentButton.removeClass('active').removeAttr('disabled', true);
        showHideLoadMoreButton((data.max_num_pages - 1) <= loadMoreArgs.page, $('.load-more__wrapper'), $grid);
      });
    });

    function multiSelectHandler(postsType) {
      if ($grid.isotope('getItemElements').length) {
        $loader.show();
      } else {
        $loader.show().css({ position: postsType === 'post' ? 'absolute' : 'relative' });
      }
      loadMoreArgs.page = 1;
      selectedCategories = $("select[multiple]")
        .map(function (index, element) {
          if ($(element).val().length) {
            return $(element).val();
          }
        })
        .get();
      loadMoreArgs.category = selectedCategories;
      const offset = $loadMoreButton.attr('data-offset');
      const additionalPosts = $loadMoreButton.attr('data-additional-posts');
      let nextPosts = getAdditionalPosts({ ...loadMoreArgs, offset, additionalPosts, type: postsType || 'category' });
      nextPosts.then(function (data) {
        if (data.html) {
          const isotopeElements = $.parseHTML($.trim(data.html));
          $grid.isotope('remove', $grid.isotope('getItemElements'));
          $grid.isotope('insert', isotopeElements);
          showHideLoadMoreButton(data.max_num_pages <= loadMoreArgs.page, $('.load-more__wrapper'), $grid);
        } else {
          showHideLoadMoreButton(true, $('.load-more__wrapper'), $grid);
          $grid.isotope('remove', $grid.isotope('getItemElements'));
        }

        $grid.imagesLoaded()
          .done(function () {
            $grid.isotope('layout');
            $loader.hide().css({ position: 'absolute' });
          });
      });
    }

    if (selectedCategories.length) {
      multiSelectHandler('category');
    } else {
      multiSelectHandler('post');
    }


    const mSelect = $("select[multiple]").multiselect({
      showCheckbox: false,
      selectAll: false,
      onLoad: function () {
        $('.grid-filter').addClass('active');
        $filterContentPostion = $('#filter-content').offset().top + 30 - $('#masthead-sticky-wrapper').height();
      },
      onOptionClick: function (element, option) {
        multiSelectHandler();
        stickyFilter.sticky('update')
        if ($(window).width() < 768) {
          var el = $(element);
          var optionsWrap = el.siblings(".ms-options-wrap")
          var msOptions = optionsWrap.find("> .ms-options");
          var optionsList = msOptions.find("> ul");

          msOptions.css({
            height: (optionsList.find('li.selected').height() || 0)
              * optionsList.find('li.selected').length
          });
          optionsWrap.removeClass('ms-active');
        }
      },
      onSelectAll: function () {
        multiSelectHandler();
        if ($(window).width() < 768) {
          $("html, body").animate({ scrollTop: 0 }, 800);
        }

      }
    });

    if (mSelect && getSelectedCategories("select[multiple]").length) {
      mSelect.multiselect('onBrowserBackAndForward');
    }

    $('#grid-filter').on('sticky-start', function () {
      if (getSelectedCategories("select[multiple]").length) {
        $(this).addClass('with-categories');
      }
      $('.ms-options-wrap.ms-active').each(function () {
        if ($(this).siblings('.' + $(this).attr('id') + '.jqmsLoaded')[0]) {
          $(this).removeClass('ms-active');
          mSelect.multiselect('recalculateHeight');
        }
      });
    });

    $('#grid-filter').on('sticky-end', function () {
      $(this).removeClass('with-categories');
    });


    $('.ms-dropdown').on('click', function () {
      $("#grid-filter-sticky-wrapper").css({ height: 'auto' });
    });

    // Clear all current filters
    $('#grid-filter-clear').on('click', () => {
      $.when(!$('select[multiple]').multiselect('reset')).done(() => {
        multiSelectHandler('post');
      });
    });

    if ($(window).width() > 768) {
      stickyFilter.unstick();
    }

    $(window).on('resize', function () {
      // Rerender columns on page resize
      gridFilter.render();
    });

    $(window).on('scroll', () => {
      const $windowScroll = $(window).scrollTop();
      // If mobile device
      if ($(window).width() < 768 && $windowScroll > $filterContentPostion) {
        // If there is not active sticky filter && user has not scrolled over the filter && there are selected filter
        if (selectedCategories.length > 0) {
          if (!$("#grid-filter-sticky-wrapper").length) {
            stickyFilter.sticky(stickyFilterOptions);
          }
        } else {
          if ($("#grid-filter-sticky-wrapper").length) {
            stickyFilter.unstick();
          }
        }
      }
    });

  });
})(jQuery);